import React from 'react';
import { connect } from 'react-redux';
import COP from '../../cop/components/App/App';
import { getCustomerType } from '../../effectiveWarning/state/selectors';
import { getPayeeById } from '../../states/commonSelectors/selectors';
import { pages } from '../../states/page/actions';
import { getCopDetails } from '../../helpers/fieldHelpers';
import { getUserId } from '../../states/user/selectors';

/**
 * @note I don't like this component existing as it adds another degree of separation in understanding
 * what components are being rendered by what parents.
 * The only value this component adds is it forcibly defaults the `initStore` prop to `false`
 * and also builds the copDetails prop from redux store state and props.
 * However, it also restricts any further props from being added.
 * I get that this saves repetition in not having to add to `connect` for every screen
 * that uses COP. But it feels premature to optimize this, given the range of issues we have had.
 * All of this is up for discussion of course.
 * Kraig Walker – 29th April 2022
 */
function COPCheck({
	copCheckTriggered,
	copDetails,
	handleComplete,
	handleCancel,
	handleEdit,
	payeeId,
	handleKeepAsIs,
	sessionCOPChecks,
}) {
	return (
		<COP
			cop={copDetails}
			copCheckTriggered={copCheckTriggered}
			handleComplete={handleComplete}
			handleCancel={handleCancel}
			handleEdit={handleEdit}
			initStore={false}
			payeeId={payeeId}
			handleKeepAsIs={handleKeepAsIs}
			sessionCOPChecks={sessionCOPChecks}
		/>
	);
}

const ConnectedCOPCheck = connect((state, { payeeId, reference }) => ({
	copDetails: getCopDetails({
		payee: getPayeeById(state, payeeId),
		page: pages.COP.MakeMatch,
		customerId: getUserId(state),
		customerType: getCustomerType(state),
		beneficiaryId: payeeId,
		updatedRef: reference,
	}),
}))(COPCheck);

export { ConnectedCOPCheck as COPCheck };
